import * as Sentry from '@sentry/react';

// normalizeDsn strips dashes from GlitchTip UUID keys.
// The Sentry SDK rejects DSN usernames containing dashes.
function normalizeDsn(dsn: string): string {
  try {
    const url = new URL(dsn);
    if (url.username.includes('-')) {
      url.username = url.username.replace(/-/g, '');
      return url.toString();
    }
    return dsn;
  } catch {
    return dsn;
  }
}

export function initSentry(suiteTag: string): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    // No DSN configured — skip Sentry init (local dev, or env var not set)
    return;
  }

  Sentry.init({
    dsn: normalizeDsn(dsn),
    environment: import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || 'development',
    release: `hw-${suiteTag}@${import.meta.env.VITE_GIT_SHA || 'local'}`,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    beforeSend(event, hint) {
      const error = hint.originalException;
      // Filter noise: network errors, ResizeObserver, aborts
      if (error instanceof TypeError && error.message.includes('Failed to fetch')) return null;
      if (error instanceof Error && error.message.includes('ResizeObserver')) return null;
      if (error instanceof Error && error.name === 'AbortError') return null;
      return event;
    },
  });

  Sentry.setTag('spa', suiteTag);
}
